export default "__VITE_ASSET__104d9d3d__"